import { Button } from "@mui/material";

export default function ErrorFallback() {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <h2>Something went wrong</h2>
        <p>Please refresh the page or try again later.</p>
        <Button variant="contained" onClick={() => window.location.reload()}>Reload page</Button>
      </div>
    );
  }
  